import { isMacOs } from './os-utils-flow';

export const normalizeShortcut = (unicodeString: string) => {
    const value = unicodeString
        // Replace Unicode Shift (⇧, \u21E7) with 'shift'
        .replace(/\\u21E7|⇧/gi, 'shift')
        .replace(/\\u2318|⌘/gi, 'cmd')
        // Replace Unicode Ctrl (⌃, \u2303) with 'ctrl'
        .replace(/\\u2303|⌃/gi, 'ctrl')
        // Replace cmdOrCtrl with the appropriate key based on the OS
        .replace(/cmdOrCtrl/gi, isMacOs() ? 'cmd' : 'ctrl')
        // Replace Unicode letters (\u0061-\u007A) with a-z
        .replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
            const char = String.fromCharCode(parseInt(code, 16));
            return char.toLowerCase();
        })
        // Replace spaces with '+'
        .replace(/\s+/g, '+')
        .toLowerCase();
    return value;
};

export const denormalizeShortcut = (shortcut: string) => {
    const value = shortcut
        // Replace 'shift' with Unicode Shift (⇧, \u21E7)
        .replace(/shift/gi, '\u21E7')
        // Replace 'cmd' with Unicode Cmd (⌘, \u2318)
        .replace(/cmd/gi, '\u2318')
        // Replace 'ctrl' with Unicode Ctrl (⌃, \u2303)
        .replace(/ctrl/gi, '\u2303')
        // Replace '+' with spaces
        .replace(/\+/g, ' ')
        // Convert lowercase letters (a-z) back to their Unicode representation (\u0061-\u007A)
        .replace(
            /[a-z]/g,
            (char) => `\\u${char.charCodeAt(0).toString(16).padStart(4, '0')}`,
        );
    return value;
};

export const normalizeShortcutToDisplay = (unicodeString: string) => {
    if (!unicodeString) {
        return '';
    }
    const value = unicodeString
        // Replace Unicode Shift (⇧, \u21E7) with '⇧'
        .replace(/\\u21E7|⇧/gi, '⇧')
        // Replace Unicode Cmd (⌘, \u2318) with '⌘'
        .replace(/\\u2318|⌘/gi, '⌘')
        // Replace Unicode Ctrl (⌃, \u2303) with '⌃'
        .replace(/\\u2303|⌃/gi, '⌃')
        // Replace cmdOrCtrl with the appropriate key based on the OS
        .replace(/cmdOrCtrl/gi, isMacOs() ? '⌘' : '⌃')
        // Replace Unicode letters (\u0061-\u007A) with a-z
        .replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
            const char = String.fromCharCode(parseInt(code, 16));
            return char.toLowerCase();
        })
        // Replace '+' with spaces between symbols
        .replace(/\+/g, ' + ')
        .toUpperCase();

    return value;
};

export const isCmdOrCtrlPressed = (event: KeyboardEvent) => {
    return isMacOs() ? event.metaKey : event.ctrlKey;
};
